export const staffDashboard = {
  title: 'Portal Kakitangan',
  subtitle: 'Portal Kakitangan',
  settings: 'Tetapan',
  
  // Quick Actions
  quickActions: 'Tindakan Pantas',
  scanForCheckout: 'Imbas untuk Pembayaran',
  menuItems: 'Item Menu',
  editCustomer: 'Edit Pelanggan',
  scanReceipt: 'Imbas Resit',
  viewTransactions: 'Lihat Transaksi',
  
  // Customer Verification
  customerVerified: 'Pelanggan Disahkan',
  welcomeBack: 'Selamat kembali',
  firstVisit: 'Lawatan Pertama!',
  birthdayBonus: 'Bonus Hari Jadi!',
  continueToCheckout: 'Teruskan ke Pembayaran',
  
  // Checkout
  checkout: 'Pembayaran',
  billAmount: 'Jumlah Bil',
  enterBillAmount: 'Masukkan jumlah bil',
  billAmountPlaceholder: '0.00',
  availableBalance: 'Baki Tersedia',
  redeemAmount: 'Jumlah Tebus',
  enterRedeemAmount: 'Masukkan jumlah untuk tebus',
  redeemAmountPlaceholder: '0.00',
  maxRedeemable: 'Maksimum boleh tebus',
  summary: 'Ringkasan',
  originalAmount: 'Jumlah Asal',
  discount: 'Diskaun (5%)',
  vcRedeemed: 'VC Ditebus',
  finalAmount: 'Jumlah Akhir',
  processCheckout: 'Proses Pembayaran',
  processing: 'Memproses...',
  
  // Transaction Success
  transactionSuccess: 'Transaksi Berjaya!',
  transactionId: 'ID Transaksi',
  customer: 'Pelanggan',
  vcEarned: 'VC Diperolehi',
  birthdayBonusEarned: 'Bonus Hari Jadi',
  done: 'Selesai',
  
  // Customer Lookup
  lookupCustomer: 'Cari Pelanggan',
  searchByEmail: 'Cari mengikut e-mel atau nama',
  search: 'Cari',
  scanQR: 'Imbas Kod QR',
  noCustomerFound: 'Pelanggan tidak dijumpai',
  
  // Edit Customer
  editCustomerTitle: 'Edit Pelanggan',
  fullName: 'Nama Penuh',
  email: 'E-mel',
  birthday: 'Hari Jadi',
  optional: 'Pilihan',
  saveChanges: 'Simpan Perubahan',
  saving: 'Menyimpan...',
  
  // QR Scanner
  scanCustomerQR: 'Imbas QR Pelanggan',
  pointCamera: 'Arahkan kamera ke kod QR pelanggan',
  cancel: 'Batal',
  
  // Receipt OCR
  scanReceiptTitle: 'Imbas Resit',
  uploadReceipt: 'Muat Naik Resit',
  takePhoto: 'Ambil Gambar',
  processingReceipt: 'Memproses...',
  extracting: 'Mengekstrak data dari resit...',
  
  // Menu Management
  menuManagement: 'Pengurusan Menu',
  items: 'item',
  available: 'tersedia',
  import: 'Import',
  export: 'Eksport',
  add: 'Tambah',
  totalItems: 'Jumlah Item',
  availableItems: 'Tersedia',
  lowStock: 'Stok Rendah',
  categories: 'Kategori',
  searchPlaceholder: 'Cari mengikut nama atau kategori...',
  allItems: 'Semua Item',
  meatPoultry: 'Daging & Ayam',
  seafood: 'Makanan Laut',
  vegetables: 'Sayur-sayuran',
  processed: 'Makanan Proses',
  noodlesRice: 'Mee & Nasi',
  herbsSpices: 'Herba & Rempah',
  others: 'Lain-lain',
  bulkActions: 'Tindakan Pukal',
  selected: 'dipilih',
  delete: 'Padam',
  toggleAvailability: 'Tukar Ketersediaan',
  sortBy: 'Susun mengikut',
  name: 'Nama',
  price: 'Harga',
  stock: 'Stok',
  category: 'Kategori',
  viewMode: 'Paparan',
  list: 'Senarai',
  grid: 'Grid',
  noItems: 'Tiada item menu dijumpai',
  noItemsDesc: 'Mulakan dengan menambah item menu pertama atau import dari CSV',
  
  // Menu Item Form
  addMenuItem: 'Tambah Item Menu',
  editMenuItem: 'Edit Item Menu',
  itemName: 'Nama Item',
  required: 'Wajib',
  itemNamePlaceholder: 'cth., Dada Ayam, Udang Harimau',
  itemNameHint: 'Gunakan nama yang sama seperti di resit untuk padanan OCR yang lebih baik',
  priceRM: 'Harga (RM)',
  unit: 'Unit',
  unitPlaceholder: 'Kg, Pek, Kotak',
  nutritionalInfo: 'Maklumat Pemakanan (per 100g)',
  calories: 'Kalori',
  protein: 'Protein (g)',
  fat: 'Lemak (g)',
  inventory: 'Inventori',
  stockQuantity: 'Kuantiti Stok',
  lowStockAlert: 'Amaran Stok Rendah',
  availableForSale: 'Tersedia untuk Dijual',
  toggleUnavailable: 'Tukar untuk tandakan item tidak tersedia',
  notes: 'Nota',
  notesPlaceholder: 'Nota atau penerangan tambahan...',
  addItem: 'Tambah Item',
  updateItem: 'Kemas Kini Item',
  
  // Menu Item Import
  importMenuItems: 'Import Item Menu',
  howToImport: 'Cara Import',
  importStep1: 'Muat turun templat CSV di bawah (termasuk arahan format dan contoh)',
  importStep2: 'Isi item menu anda - nama dan kategori adalah wajib',
  importStep3: 'Simpan baris arahan (bermula dengan #) untuk rujukan - ia akan diabaikan semasa import',
  importStep4: 'Muat naik fail CSV yang telah lengkap',
  importStep5: 'Semak sebarang ralat pengesahan dan betulkannya',
  importStep6: 'Klik Import untuk tambah item ke menu anda',
  csvFormatPreview: 'Pratonton Format CSV:',
  formatLine1: 'Baris pertama: Pengepala lajur (wajib)',
  formatLine2: 'Baris kedua: Arahan (pilihan, akan dilangkau)',
  formatLine3: 'Baris berikutnya: Item menu anda',
  downloadTemplate: 'Muat Turun Templat CSV',
  uploadCSV: 'Muat Naik Fail CSV',
  clickToUpload: 'Klik untuk muat naik fail CSV',
  maxFileSize: 'Saiz fail maksimum: 5MB',
  validationErrors: 'Ralat Pengesahan',
  importComplete: 'Import Selesai',
  successfullyImported: 'Berjaya diimport',
  failed: 'Gagal',
  totalProcessed: 'Jumlah diproses',
  validCategories: 'Kategori Sah:',
  importItems: 'Import Item',
  
  // Transactions Page
  transactions: 'Transaksi',
  transaction: 'transaksi',
  period: 'Tempoh',
  oneDay: '1 Hari',
  sevenDays: '7 Hari',
  thirtyDays: '30 Hari',
  all: 'Semua',
  date: 'Tarikh',
  amount: 'Jumlah',
  noTransactions: 'Tiada transaksi dijumpai untuk tempoh yang dipilih',
  totalAmount: 'Jumlah Keseluruhan',
  
  // Settings
  profile: 'Profil',
  memberSince: 'Ahli sejak',
  preferences: 'Keutamaan',
  language: 'Bahasa',
  notifications: 'Pemberitahuan',
  about: 'Tentang',
  privacyPolicy: 'Dasar Privasi',
  termsOfService: 'Terma Perkhidmatan',
  appVersion: 'Versi Aplikasi',
  logout: 'Log keluar',
  
  // Toast Messages
  customerNotFound: 'Pelanggan tidak dijumpai. Sila semak kod QR dan cuba lagi.',
  transactionFailed: 'Gagal memproses transaksi',
  customerUpdated: 'Butiran pelanggan berjaya dikemas kini!',
  receiptScanned: 'Resit diimbas!',
  itemsMatched: 'item dipadankan',
  confidence: 'Keyakinan',
  
  ocr: {
    linkSuccess: 'Resit dipautkan ke transaksi {customer}! (Perbezaan {timeDiff}) | {items} item | Keyakinan: {confidence}%',
    scanSuccess: 'Resit diimbas! Jumlah: RM {amount}{itemsText} | Keyakinan: {confidence}% | ⚠️ Tiada transaksi sepadan ditemui - buat transaksi dahulu',
    linkError: 'Resit diimbas tetapi gagal dipautkan: {error}',
    refreshError: 'Gagal memuat semula data pelanggan',
  },

  noItemsToExport: 'Tiada item untuk dieksport',
  exportedItems: 'Dieksport',
  exportFailed: 'Gagal mengeksport item. Sila cuba lagi.',
  menuItemAdded: 'Item menu berjaya ditambah',
  menuItemUpdated: 'Item menu berjaya dikemas kini',
  failedToSave: 'Gagal menyimpan item',
  
  // Error Messages
  error: 'Ralat',
  tryAgain: 'Sila cuba lagi',
  loadingError: 'Gagal memuatkan data',
  noRestaurant: 'Tiada restoran ditetapkan ke akaun anda',
  
  // Transaction Detail Sheet
  detailSheetTitle: 'Butiran Transaksi',
  detailCustomer: 'Pelanggan',
  detailBreakdown: 'Pecahan',
  detailReceiptItems: 'Item Resit',
  detailNoItems: 'Tiada item diekstrak',
  detailFirstVisit: 'Lawatan Pertama',
  detailReceiptScanned: 'Resit Diimbas',
  detailVoided: 'Dibatal',
  voidTransaction: 'Batal Transaksi',
  voidReason: 'Sebab pembatalan',
  voidReasonPlaceholder: 'cth., Jumlah salah dimasukkan',
  confirmVoid: 'Sahkan Batal',
  cancelVoid: 'Batal',
  voidConfirmTitle: 'Batalkan Transaksi?',
  voidConfirmDesc: 'Tindakan ini tidak boleh dibuat asal. Jumlah transaksi akan ditolak daripada hasil dan VC akan ditarik balik.',
  voidSuccess: 'Transaksi berjaya dibatalkan',
};
